"use strict";function getData$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.getData$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="util.openTemporary.getData";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"6.3.15"},_a[ddSdk_1.ENV_ENUM.android]={vs:"6.3.15"},_a)),exports.getData$=getData$,exports.default=getData$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/util/openTemporary/getData.js
// module id = 1106
// module chunks = 106